import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { isEqual } from 'lodash';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import ShipperSettings from './shipper/ShipperSettings';
import AuditHistory from '../shipments/AuditHistory';
import CargomaticCard from '../../v2/card';
import CustomersActionCreators from '../../../actions/CustomersActionCreators';
import CustomerStore from '../../../stores/CustomerSearchStore';
import DataPoller from '../../ui/DataPoller';
import CommentList from '../comments/CommentList';
import RecentActivity from './recent-activity';
import { getCustomerV2, updateShipper } from '../../../utils/CustomersAPIUtils';

const POLLING_FREQUENCY = 10000;
export default function () {
  const { t } = useTranslation();
  const params = useParams();
  const { id } = params;
  const [auditItems, setAuditItems] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [comments, setComments] = useState([]);
  const [email, setEmail] = useState(null);
  const [user, setUser] = useState();

  function handleAuditChange() {
    const updatedItems = CustomerStore.getCustomerAudits();
    if (!isEqual(updatedItems, auditItems)) {
      setAuditItems(updatedItems);
      setIsLoading(false);
    }
  }
  async function fetchUser() {
    const user = await getCustomerV2(id);
    setUser(user);
    const comments =
      user.comments
        .filter((c) => c.message.length > 0)
        .sort((a, b) => moment(a.timestamp) - moment(b.timestamp))
        .reverse() || [];
    setComments(comments);
    const { email } = user;
    setEmail(email);
  }

  function getUserAudits() {
    CustomersActionCreators.fetchCustomerAudits(id, { page });
  }

  function handleAddComment(message) {
    CustomersActionCreators.updateShipperComments(id, message);
  }

  useEffect(() => {
    CustomerStore.addAuditChangeListener(handleAuditChange);

    getUserAudits();
    fetchUser();
    return () => {
      CustomerStore.removeAuditChangeListener(handleAuditChange);
      setIsLoading(true);
    };
  }, [page]);
  const renderSidebar = () => {
    return <ShipperSettings userId={id} activePage="activity" />;
  };

  const breadcrumbs = {
    pages: [
      {
        name: user?.account_name || t('SHIPPER'),
        href: `/users/${id}`,
        current: false,
      },
      { name: t('ACTIVITY'), href: `/users/${id}/activity`, current: true },
    ],
  };

  return (
    <LayoutWithSidebar
      sidebar={renderSidebar}
      breadcrumbs={breadcrumbs}
      className="py-4"
    >
      <DataPoller action={getUserAudits} frequency={POLLING_FREQUENCY} />
      {email && <RecentActivity email={email} />}
      <CargomaticCard
        className="mt-6"
        header={() => (
          <h3 className="my-0 text-xl font-medium">{t('ACCOUNT_HISTORY')}</h3>
        )}
        removeHorizontalPadding
        removeVerticalPadding
      >
        <AuditHistory
          audits={auditItems}
          paginate
          onClick={(page) => {
            setPage(page);
          }}
          currentPage={page}
          isLoading={isLoading}
        />
      </CargomaticCard>
      <div className="mt-6">
        <CargomaticCard
          removeHorizontalPadding
          removeVerticalPadding
          header={() => (
            <h3 className="my-0 text-xl font-medium">
              {t('ACCOUNT_DISCUSSION')}
            </h3>
          )}
        >
          <CommentList
            comments={comments}
            onCommentAdd={handleAddComment}
            paginate
          />
        </CargomaticCard>
      </div>
    </LayoutWithSidebar>
  );
}
